import wrapper from 'wrapper';
import facewallConfig from './facewall-config';

export default function lazyLoadImages() {
    // Lazy loading
    /* eslint-disable */
    let lazyImages = wrapper.selectAll('img.lazy');

    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries, observer) => {
            // eslint-disable-line
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    const lazyImage = entry.target;
                    loadImage(lazyImage);
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(lazyImage => {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fall back to a more compatible method here
        let active = false;

        // Load first 8 images straight away
        lazyImages.forEach((lazyImage, i) => {
            if (i < facewallConfig.lazyLoad.lazyLoadImages) {
                loadImage(lazyImage);
            }
        });

        const lazyLoad = () => {
            if (active === false) {
                active = true;

                setTimeout(() => {
                    lazyImages.forEach((lazyImage, i) => {
                        if (
                            lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                            lazyImage.getBoundingClientRect().bottom >= 0 &&
                            getComputedStyle(lazyImage).display !== 'none'
                        ) {
                            loadImage(lazyImage);

                            lazyImages = lazyImages.filter(image => image !== lazyImage);

                            if (lazyImages.length === 0) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('resize', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }
                        }
                    });
                    active = false;
                }, 200);
            }
        };

        document.addEventListener('scroll', lazyLoad);
        window.addEventListener('resize', lazyLoad);
        window.addEventListener('orientationchange', lazyLoad);
    }
}

function loadImage(lazyImage) {
    lazyImage.src = lazyImage.dataset.src;
    lazyImage.srcset = lazyImage.dataset.srcset;
    lazyImage.classList.remove('lazy');
}

/* eslint-disable */
